import { call, put, takeEvery } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import * as types from './hourlyVolumeShareActionType';
import * as actions from './hourlyVolumeShareActions';
import * as services from './hourlyVolumeShareServices';
import { downloadBase64File } from "../../../../utils/fileDownloads";


function* fetchSiteHourlyVolumeShareUnReadDetailsSaga(action) {
    try {
        const response = yield call(services.getSiteRadUnReadRvuDetails, action.payload);
        if (response?.success) {
            yield put(actions.fetchSiteHourlyVolumeShareUnReadDetailsSuccess(response.values));
        } else {
            yield put(actions.fetchSiteHourlyVolumeShareUnReadDetailsFailure('No data found'));
        }
    } catch (error) {
        console.error('RAD Site Unread RVU Details Fetch Error:', error);
        yield put(actions.fetchSiteHourlyVolumeShareUnReadDetailsFailure('Failed to fetch provider facility unread RVU details'));
        Swal.fire('Error', 'Failed to load provider facility unread RVU details', 'error');
    }
}

function* fetchSiteHourlyVolumeShareReadDetailsSaga(action) {
    try {
        const response = yield call(services.getSiteRadReadRvuDetails, action.payload);
        if (response?.success) {
            yield put(actions.fetchSiteHourlyVolumeShareReadDetailsSuccess(response.values));
        } else {
            yield put(actions.fetchSiteHourlyVolumeShareReadDetailsFailure('No data found'));
        }
    } catch (error) {
        console.error('RAD Site Read RVU Details Fetch Error:', error);
        yield put(actions.fetchSiteHourlyVolumeShareReadDetailsFailure('Failed to fetch provider facility read RVU details'));
        Swal.fire('Error', 'Failed to load provider facility read RVU details', 'error');
    }
}

// function* exportSiteHourlyVolumeShareSaga(action) {
//     try {
//         const { exportAPIURL, payload, moduleName, fileName } = action.payload;
//         const response = yield call(services.exportSiteHourlyVolumeShare, exportAPIURL, payload);
//         const base64Data = response?.values || response;
//         yield call(downloadBase64File, base64Data, moduleName, fileName);
//     } catch (error) {
//         console.error("Export error:", error);
//         yield put(actions.exportSiteHourlyVolumeShareFailure("Export failed"));
//     }
// }

function* exportSiteHourlyVolumeShareSaga(action) {
    try {
        const { exportAPIURL, payload, moduleName, fileName } = action.payload;

        const response = yield call(
            services.exportSiteHourlyVolumeShare,
            exportAPIURL,
            payload
        );

        if (response?.success) {
            const base64Data = response?.values || response;

            if (base64Data) {
                yield call(downloadBase64File, base64Data, moduleName, fileName);
            }

            yield put(actions.exportSiteHourlyVolumeShareSuccess());

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Export completed successfully.'
            });

        } else {
            yield put(
                actions.exportSiteHourlyVolumeShareFailure(
                    response?.errorMessage || 'Failed to export report'
                )
            );

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to export report.'
            });
        }

    } catch (error) {
        console.error("Export error:", error);

        yield put(
            actions.exportSiteHourlyVolumeShareFailure(
                error?.message || "Export failed"
            )
        );

        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to export facility hourly volume share report.'
        });
    }
}


function* getDropdownSiteRadSaga() {
    try {
        console.log('🎯 Saga: getDropdownSiteRadSaga triggered');
        console.log('📡 Calling API: getDropdownSiteRad');
        const response = yield call(services.getDropdownSiteRad);
        console.log('✅ API Response:', response);
        if (response?.success) {
            yield put(actions.getDropdownSiteRadSuccess(response.values));
        } else {
            yield put(actions.getDropdownSiteRadFailure('No data found'));
        }
    } catch (error) {
        console.error('Dropdown Site Provider Fetch Error:', error);
        yield put(actions.getDropdownSiteRadFailure('Failed to fetch provider facility dropdown'));
        Swal.fire('Error', 'Failed to load provider facility dropdown', 'error');
    }
}

function* getWorklistRpceIDSaga(action) {
    try {
        // Extract payload from action
        const { rpceIds } = action.payload;

        // Call API with rpceIds
        const response = yield call(services.getWorklistID, rpceIds);

        if (response?.success) {
            // Extract WorkListDropdownItems from response.values
            yield put(actions.getWorklistByRpceIdSuccess(response.values?.WorkListDropdownItems || []));
        } else {
            yield put(actions.getWorklistByRpceIdFailure('No data found'));
        }
    } catch (error) {
        console.error('Worklist Provider Sites Fetch Error:', error);
        yield put(actions.getWorklistByRpceIdFailure('Failed to fetch Worklists'));
        Swal.fire('Error', 'Failed to load Worklists', 'error');
    }
}

function* getPracticeByWorklistIDSaga(action) {
    try {
        // Extract payload from action
        const { worklistIds } = action.payload;

        // Call API with worklistIds
        const response = yield call(services.GetPracticesByWorklistID, worklistIds);
        if (response?.success) {
            // Extract PracticeDropdownItems from response.values
            yield put(actions.getPraticesByWorklistIdSuccess(response.values?.Practices || []));
        } else {
            yield put(actions.getPraticesByWorklistIdFailure('No data found'));
        }
    } catch (error) {
        console.error('Practice Fetch Error:', error);
        yield put(actions.getPraticesByWorklistIdFailure('Failed to fetch Practices'));
        Swal.fire('Error', 'Failed to load Practices', 'error');
    }
}

function* getSubPracticeByPracticeIDSaga(action) {
    try {
        // Extract payload from action
        const { practiceIds } = action.payload;

        // Call API with practiceIds
        const response = yield call(services.GetSubPracticesByPracticeID, practiceIds);
        if (response?.success) {
            // Extract SubPracticeDropdownItems from response.values
            yield put(actions.getSubPraticesByPraticeIdSuccess(response.values?.dropdownItems || []));
        } else {
            yield put(actions.getSubPraticesByPraticeIdFailure('No data found'));
        }
    } catch (error) {
        console.error('SubPractice Fetch Error:', error);
        yield put(actions.getSubPraticesByPraticeIdFailure('Failed to fetch SubPractices'));
        Swal.fire('Error', 'Failed to load SubPractices', 'error');
    }
}


export default function* siteHourlyVolumeShareSaga() {
    yield takeEvery(types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST, fetchSiteHourlyVolumeShareUnReadDetailsSaga);
    yield takeEvery(types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST, fetchSiteHourlyVolumeShareReadDetailsSaga);
    yield takeEvery(types.EXPORT_SITE_HOURLY_VOLUME_SHARE_REQUEST, exportSiteHourlyVolumeShareSaga);
    yield takeEvery(types.GET_DROPDOWN_SITE_RAD_REQUEST, getDropdownSiteRadSaga);
    yield takeEvery(types.GET_WORKLIST_BY_RPCE_ID_REQUEST, getWorklistRpceIDSaga);
    yield takeEvery(types.GET_PRATICES_BY_WORKLIST_ID_REQUEST, getPracticeByWorklistIDSaga);
    yield takeEvery(types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST, getSubPracticeByPracticeIDSaga);
}